import React from "react";
import { v4 as uuidv4 } from "uuid";
import StyledList from "./styles";
import Utils from "../../../Utils";

function JSONViewer({ data }) {
  const renderNode = (node) => {
    const key = uuidv4();

    if (typeof node === "object" && node !== null) {
      return (
        <ul className="list">
          {Object.keys(node).map((childKey) => (
            <li
              className="list-item"
              key={childKey}
            >
              {node[childKey] ? <span>{childKey}</span> : null}
              {node[childKey] ? renderNode(node[childKey]) : null}
            </li>
          ))}
        </ul>
      );
    } else {
      return (
        <div
          className="content"
          key={key}
        >
          {typeof node === "string" ? Utils.nl2br(node) : node}
        </div>
      );
    }
  };

  return <StyledList>{renderNode(data)}</StyledList>;
}

export default JSONViewer;
